import React from 'react';
import { FormItem, Input, Space, Title } from '@vette/ui-components';
import { FormItemNames } from './form';
import { Grid } from 'antd';

type Props = {
  customHeadline: false | string;
  zipCodeInput: boolean;
  isFormDisabled?: boolean;
};

export const CustomJobDetail: React.FC<Props> = ({
  customHeadline,
  zipCodeInput,
  isFormDisabled,
}) => {
  const { xs } = Grid.useBreakpoint();
  return (
    <Space direction="vertical" size={12}>
      <Title level={4}>{customHeadline}</Title>
      {zipCodeInput && (
        <FormItem
          name={FormItemNames.zipCode}
          label={!xs && 'What’s your zipcode?'}
          validateTrigger={['onBlur']}
          normalize={value => {
            // pick only digits and spaces:
            return value.replace(/[^\d\s]/g, '');
          }}
          rules={[{ required: true, message: 'Zip code is required' }]}
        >
          <Input
            maxLength={10}
            aria-label="Zip Code"
            placeholder="Enter zip code"
            disabled={isFormDisabled}
            size="large"
          />
        </FormItem>
      )}
    </Space>
  );
};
